module.exports = __webpack_public_path__ + "static/img/jindubg.78c18b28.png";